import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactDOM from 'react-dom';

const MailInGiftOccasionModal = ({ isOpen, onClose, onSelectOccasion }) => {
  const { t } = useTranslation();
  const [selectedOccasion, setSelectedOccasion] = useState('');
  const [showHolidayOptions, setShowHolidayOptions] = useState(false);
  
  const holidayOptions = [
    { id: 'christmas', name: t('gift_card.occasions.christmas'), emoji: '🎄' },
    { id: 'hanukkah', name: t('gift_card.occasions.hanukkah'), emoji: '🕎' },
    { id: 'kwanzaa', name: t('gift_card.occasions.kwanzaa'), emoji: '🕯️' },
    { id: 'diwali', name: t('gift_card.occasions.diwali'), emoji: '🪔' },
    { id: 'eid', name: t('gift_card.occasions.eid'), emoji: '🌙' },
    { id: 'lunar_new_year', name: t('gift_card.occasions.lunar_new_year'), emoji: '🧧' },
    { id: 'happy_holidays', name: t('gift_card.occasions.general_holiday'), emoji: '✨' },
  ];

  const occasions = [
    {
      id: 'birthday',
      name: t('gift_card.occasions.birthday'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 15.546c-.523 0-1.046.151-1.5.454a2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.546 2.546 0 00-1.5-.454M9 6v2m3-2v2m3-2v2M9 3h.01M12 3h.01M15 3h.01M21 21v-7a2 2 0 00-2-2H5a2 2 0 00-2 2v7h18zm-3-9v-2a2 2 0 00-2-2H8a2 2 0 00-2 2v2h12z" />
        </svg>
      ),
      color: 'from-pink-500 to-purple-500',
      bgColor: 'bg-gradient-to-br from-pink-50 to-purple-50',
    },
    {
      id: 'holiday',
      name: t('gift_card.occasions.holiday'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      color: 'from-red-500 to-green-500',
      bgColor: 'bg-gradient-to-br from-red-50 to-green-50',
    },
    {
      id: 'anniversary',
      name: t('gift_card.occasions.anniversary'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      color: 'from-red-500 to-pink-600',
      bgColor: 'bg-gradient-to-br from-red-50 to-pink-50',
    },
    {
      id: 'celebration',
      name: t('gift_card.occasions.celebration'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
        </svg>
      ),
      color: 'from-yellow-500 to-orange-600',
      bgColor: 'bg-gradient-to-br from-yellow-50 to-orange-50',
    },
    {
      id: 'thankyou',
      name: t('gift_card.occasions.thankyou'),
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3zM7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3v11z"/>
        </svg>
      ),
      color: 'from-blue-500 to-teal-600',
      bgColor: 'bg-gradient-to-br from-blue-50 to-teal-50',
    },
    {
      id: 'mothers_day',
      name: t('gift_card.occasions.mothers_day'),
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <circle cx="12" cy="10" r="2" fill="currentColor"/>
          <path d="M12 4C10.9 4 10 4.9 10 6C10 6.3 10.1 6.6 10.2 6.9C9.6 6.3 8.8 6 8 6C6.9 6 6 6.9 6 8C6 9.1 6.9 10 8 10C8.8 10 9.6 9.7 10.2 9.1C10.1 9.4 10 9.7 10 10C10 10.3 10.1 10.6 10.2 10.9C9.6 10.3 8.8 10 8 10C6.9 10 6 10.9 6 12C6 13.1 6.9 14 8 14C8.8 14 9.6 13.7 10.2 13.1C10.1 13.4 10 13.7 10 14C10 15.1 10.9 16 12 16C13.1 16 14 15.1 14 14C14 13.7 13.9 13.4 13.8 13.1C14.4 13.7 15.2 14 16 14C17.1 14 18 13.1 18 12C18 10.9 17.1 10 16 10C15.2 10 14.4 10.3 13.8 10.9C13.9 10.6 14 10.3 14 10C14 9.7 13.9 9.4 13.8 9.1C14.4 9.7 15.2 10 16 10C17.1 10 18 9.1 18 8C18 6.9 17.1 6 16 6C15.2 6 14.4 6.3 13.8 6.9C13.9 6.6 14 6.3 14 6C14 4.9 13.1 4 12 4Z"/>
          <path d="M12 16L12 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      color: 'from-pink-400 to-rose-500',
      bgColor: 'bg-gradient-to-br from-pink-50 to-rose-50',
    },
    {
      id: 'fathers_day',
      name: t('gift_card.occasions.fathers_day'),
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <rect x="10" y="2" width="4" height="1.5" rx="0.3"/>
          <path d="M10.5 3.5 L10 4.5 L9.5 6 L9 8 L10 16 L11 20 L12 22 L13 20 L14 16 L15 8 L14.5 6 L14 4.5 L13.5 3.5 Z"/>
          <path d="M10.5 4 L11.5 3.5 L12.5 3.5 L13.5 4 L13 5 L12 6 L11 5 Z" opacity="0.4"/>
        </svg>
      ),
      color: 'from-blue-500 to-indigo-600',
      bgColor: 'bg-gradient-to-br from-blue-50 to-indigo-50',
    },
    {
      id: 'wedding',
      name: 'Wedding',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <circle cx="8" cy="12" r="5" fill="none" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="16" cy="12" r="5" fill="none" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M11 12C11 14 10 15 8 15C6 15 5 14 5 12C5 10 6 9 8 9C10 9 11 10 11 12Z" fill="none" stroke="currentColor" strokeWidth="1"/>
          <path d="M19 12C19 14 18 15 16 15C14 15 13 14 13 12C13 10 14 9 16 9C18 9 19 10 19 12Z" fill="none" stroke="currentColor" strokeWidth="1"/>
        </svg>
      ),
      color: 'from-rose-400 to-pink-500',
      bgColor: 'bg-gradient-to-br from-rose-50 to-pink-50',
    },
    {
      id: 'engagement',
      name: 'Engagement',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <circle cx="12" cy="15" r="6" fill="none" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M9 6L12 3L15 6L13 9L12 10L11 9L9 6Z" fill="currentColor"/>
          <path d="M12 10L12 12" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      color: 'from-purple-400 to-pink-500',
      bgColor: 'bg-gradient-to-br from-purple-50 to-pink-50',
    },
    {
      id: 'baby_shower',
      name: 'Baby Shower',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <rect x="6" y="10" width="12" height="10" fill="none" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M6 10L18 10L18 12L6 12Z" fill="currentColor"/>
          <path d="M12 4C10.5 4 10 5 10 6L10 10L14 10L14 6C14 5 13.5 4 12 4Z" fill="currentColor"/>
          <circle cx="10" cy="6" r="1.5" fill="currentColor"/>
          <circle cx="14" cy="6" r="1.5" fill="currentColor"/>
          <line x1="12" y1="10" x2="12" y2="20" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      color: 'from-cyan-400 to-blue-400',
      bgColor: 'bg-gradient-to-br from-cyan-50 to-blue-50',
    },
    {
      id: 'new_baby',
      name: 'New Baby',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      color: 'from-yellow-400 to-amber-400',
      bgColor: 'bg-gradient-to-br from-yellow-50 to-amber-50',
    },
    {
      id: 'graduation',
      name: 'Graduation',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path d="M12 14l9-5-9-5-9 5 9 5z" />
          <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" />
        </svg>
      ),
      color: 'from-emerald-500 to-teal-600',
      bgColor: 'bg-gradient-to-br from-emerald-50 to-teal-50',
    },
    {
      id: 'retirement',
      name: 'Retirement',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      color: 'from-amber-500 to-orange-600',
      bgColor: 'bg-gradient-to-br from-amber-50 to-orange-50',
    },
    {
      id: 'housewarming',
      name: 'Housewarming',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
      color: 'from-green-500 to-emerald-600',
      bgColor: 'bg-gradient-to-br from-green-50 to-emerald-50',
    },
    {
      id: 'memorial',
      name: 'In Remembrance',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <ellipse cx="12" cy="6" rx="2" ry="3" fill="currentColor" opacity="0.6"/>
          <path d="M12 4C11.5 4 11 5 11 6C11 7 11.5 8 12 8C12.5 8 13 7 13 6C13 5 12.5 4 12 4Z" fill="currentColor"/>
          <rect x="10" y="8" width="4" height="12" rx="0.5" fill="currentColor"/>
          <ellipse cx="12" cy="20" rx="3" ry="1" fill="currentColor" opacity="0.4"/>
          <path d="M9 20L9 21L15 21L15 20" stroke="currentColor" strokeWidth="0.5"/>
        </svg>
      ),
      color: 'from-slate-400 to-gray-500',
      bgColor: 'bg-gradient-to-br from-slate-50 to-gray-50',
    },
    {
      id: 'pet',
      name: 'Pet Celebration',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <ellipse cx="12" cy="16" rx="3.5" ry="4" fill="currentColor"/>
          <ellipse cx="7.5" cy="10" rx="1.8" ry="2.5" fill="currentColor"/>
          <ellipse cx="11" cy="8" rx="1.8" ry="2.5" fill="currentColor"/>
          <ellipse cx="14.5" cy="8" rx="1.8" ry="2.5" fill="currentColor"/>
          <ellipse cx="17" cy="10" rx="1.8" ry="2.5" fill="currentColor"/>
        </svg>
      ),
      color: 'from-orange-400 to-red-500',
      bgColor: 'bg-gradient-to-br from-orange-50 to-red-50',
    },
    {
      id: 'farewell',
      name: 'Farewell',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M8 14C8 12 9 11 10 11C11 11 11 12 11 13L11 17L10 18L8 17L8 14Z"/>
          <path d="M11 13L11 8C11 6 12 5 13 5C14 5 14 6 14 8L14 13"/>
          <path d="M14 13L14 6C14 4.5 15 4 16 4C17 4 17 5 17 6L17 13"/>
          <path d="M17 13L17 8C17 7 18 7 18.5 7.5C19 8 19 9 19 10L19 14C19 16 18 18 16 19C14 20 11 19 10 18L8 17"/>
          <path d="M13 3L13.5 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.7"/>
          <path d="M16 3L17 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.7"/>
          <path d="M19 5L20.5 3.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.7"/>
        </svg>
      ),
      color: 'from-indigo-500 to-purple-600',
      bgColor: 'bg-gradient-to-br from-indigo-50 to-purple-50',
    },
    {
      id: 'custom',
      name: 'Custom',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
        </svg>
      ),
      color: 'from-purple-500 to-blue-600',
      bgColor: 'bg-gradient-to-br from-purple-50 to-blue-50',
    },
  ];

  if (!isOpen) return null;

  const handleOccasionClick = (occasionId) => {
    if (occasionId === 'holiday') {
      setShowHolidayOptions(true);
    } else {
      setSelectedOccasion(occasionId);
    }
  };

  const handleHolidaySelect = (holidayId) => {
    setSelectedOccasion(holidayId);
    setShowHolidayOptions(false);
  };

  const handleNext = () => {
    if (selectedOccasion) {
      onSelectOccasion(selectedOccasion);
    }
  };

  const modalContent = (
    <div 
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-[9999]"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-2xl w-full max-w-4xl max-h-[90vh] my-4 sm:my-8 shadow-2xl flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-blue-500 to-purple-500 text-white p-4 sm:p-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div className="flex-1 min-w-0 pr-2">
              <h2 className="text-lg sm:text-2xl font-bold truncate">{t('gift_flow.create_perfect_gift')}</h2>
              <p className="text-xs sm:text-sm text-blue-100 mt-1 truncate">
                {t('gift_flow.send_frame_as_gift')}
              </p>
            </div>
            <button
              onClick={onClose}
              className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          {/* Progress Steps */}
          <div className="flex items-center gap-1 sm:gap-2 mt-4 sm:mt-6">
            <div className="flex items-center gap-1 sm:gap-2">
              <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-white text-blue-600 flex items-center justify-center text-xs sm:text-sm font-bold">
                1
              </div>
              <span className="text-xs sm:text-sm font-medium hidden sm:inline">{t('gift_flow.design_step')}</span>
            </div>
            <div className="flex-1 h-1 bg-white/30 rounded mx-1"></div>
            <div className="flex items-center gap-1 sm:gap-2">
              <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-white/30 text-white flex items-center justify-center text-xs sm:text-sm font-bold">
                2
              </div>
              <span className="text-xs sm:text-sm font-medium text-white/70 hidden sm:inline">{t('gift_flow.review_sign_step')}</span>
            </div>
          </div>
        </div>

        {/* Body - Scrollable Content */}
        <div className="p-4 sm:p-6 overflow-y-auto flex-1">
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Choose Occasion</h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 relative">
              {occasions.map((occasion) => (
                <div key={occasion.id} className="relative">
                  <button
                    onClick={() => handleOccasionClick(occasion.id)}
                    className={`w-full p-2 rounded-xl border-2 transition-all ${
                      selectedOccasion === occasion.id || (occasion.id === 'holiday' && showHolidayOptions)
                        ? `border-blue-500 ${occasion.bgColor} shadow-lg scale-105`
                        : 'border-gray-200 bg-white hover:border-gray-300'
                    }`}
                  >
                    <div className="flex flex-col items-center gap-1">
                      <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${occasion.color} flex items-center justify-center text-white`}>
                        {occasion.icon}
                      </div>
                      <span className="text-xs font-semibold text-gray-700">
                        {occasion.id === 'holiday' && selectedOccasion && holidayOptions.find(h => h.id === selectedOccasion)
                          ? holidayOptions.find(h => h.id === selectedOccasion).name
                          : occasion.name}
                      </span>
                    </div>
                  </button>
                  
                  {/* Holiday Sub-Options - Centered Below Holiday Button (Spans 3 Columns) */}
                  {occasion.id === 'holiday' && showHolidayOptions && (
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 z-20 w-[95vw] max-w-[600px]">
                      <div className="p-4 bg-gradient-to-br from-red-50 to-green-50 rounded-xl border-2 border-red-300 shadow-xl max-h-[50vh] overflow-y-auto">
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Choose Holiday Type</h4>
                        <div className="grid grid-cols-2 gap-2">
                          {holidayOptions.map((holiday) => (
                            <button
                              key={holiday.id}
                              onClick={() => handleHolidaySelect(holiday.id)}
                              className={`p-3 rounded-lg border-2 transition-all text-sm ${
                                selectedOccasion === holiday.id
                                  ? 'border-red-500 bg-red-100 font-semibold'
                                  : 'border-gray-200 bg-white hover:border-red-300'
                              }`}
                            >
                              {holiday.name}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer - Fixed at Bottom */}
        <div className="flex items-center justify-between gap-4 p-4 sm:p-6 border-t border-gray-200 flex-shrink-0">
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-800 font-medium text-sm sm:text-base transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleNext}
            disabled={!selectedOccasion}
            className={`px-6 py-2.5 rounded-lg font-bold text-sm sm:text-base transition-all ${
              selectedOccasion
                ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white hover:opacity-90 shadow-lg'
                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
            }`}
          >
            Next
          </button>
        </div>

      {/* Removed separate holiday modal - now inline */}

      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default MailInGiftOccasionModal;
